<template>
    <div class="bjex-main" v-loading="loading">
        <el-page-header @back="goBack"> </el-page-header>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
            style="margin-top: 20px;">
            <el-form-item label="资源名称" prop="resTitle">
                <el-input v-model="ruleForm.resTitle" style="width: 350px;"></el-input>
                <span style="color: red;font-size: 12px;    margin-left: 10px;">资源名称文字不超过50字</span>
            </el-form-item>
            <el-form-item label="资源类型" prop="resTypeIds">
                <el-checkbox-group v-model="ruleForm.resTypeIds">
                    <el-checkbox :label="item.id" v-for="item in resource_typelist" :key="item.id">{{ item.name
                        }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="资源来源" prop="resSourceId">
                <el-radio-group v-model="ruleForm.resSourceId">
                    <el-radio :label="item.id" v-for="item in resource_originlist" :key="item.id">{{ item.name
                        }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="资源阶段" prop="resStepIds">
                <el-checkbox-group v-model="ruleForm.resStepIds">
                    <el-checkbox :label="item.id" v-for="item in resource_steplist" :key="item.id">{{ item.name
                        }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="资源介绍">
                <div style="border: 1px solid #ccc; width: 1000px">
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor1" :defaultConfig="toolbarConfig"
                        :mode="mode" />
                    <Editor style="height: 400px; overflow-y: hidden" v-model="ruleForm.resContent"
                        :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated1" />
                </div>
            </el-form-item>
            <el-form-item label="资源文件" prop="resourceList">
                <div>
                    <el-upload multiple class="upload-demo" :action="upload" :data="datas"
                        :file-list="ruleForm.resourceList" :on-success="handleAvatarSuccess" :on-remove="handleRemove"
                        :on-preview="handlePreview">
                        <el-button size="small" icon="el-icon-upload">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">支持扩展名：.zip .doc .docx .pdf .jpg.ppt.Mp4.Mp3.xlsx</div>
                    </el-upload>
                </div>
                <!-- <div>
                    <el-button size="small" @click="ossDialog = true, queryVideoList()">资源库选择资源</el-button>
                    <div>已选：</div>
                    <div style="line-height: 30px;padding-left: 20px;" v-for="item in classinfo" :key="item.name">
                        {{ item.name }}</div>
                </div> -->
            </el-form-item>
            <!-- <el-form-item label="开放权限">
                <el-checkbox-group v-model="ruleForm.checkList">
                    <el-checkbox :label="item.id" v-for="item in bookLevelList" :key="item.id">{{ item.name
                        }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item> -->
            <el-form-item label="使用对象" prop="userType">
                <el-checkbox-group v-model="ruleForm.userType">
                    <el-checkbox :label="item.id" v-for="item in xuelist" :key="item.id">{{ item.name
                        }}</el-checkbox>
                </el-checkbox-group>
                <!-- <el-checkbox-group v-model="ruleForm.userType">
                    <el-checkbox label="0">老师使用</el-checkbox>
                    <el-checkbox label="1">学生使用</el-checkbox>
                </el-checkbox-group> -->
            </el-form-item>
            <el-form-item>
                <div style="color: rgba(255, 0, 0, 1);">温馨提示：本校添加的资源，仅本校师生可以查阅学习下载！</div>
            </el-form-item>
            
            <el-form-item>
                <el-button @click="resetForm('ruleForm')">取消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确定添加</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="OSS资源选取" :visible.sync="ossDialog" width="900px" :modal-append-to-body='false'>
            <div>
                <span @click="topUrl(item)" class="url_click" :class="{ url_click_c: index > 0 }"
                    v-for="(item, index) in ossUrl" :key="index">{{ item }}</span>
            </div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item style="margin-bottom: 15px">
                    <el-input size="small" v-model="prefix" placeholder="按名称前缀过滤"
                        @keyup.enter.native="queryVideoList"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px">
                    <el-button size="small" type="primary" @click="queryOss">查询</el-button>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px">
                    <el-form-item class="class-save">
                        <el-button-group>
                            <el-button @click="queryVideoList('marker')" :disabled="!marker" size="small" type="primary"
                                icon="el-icon-arrow-left">上一页</el-button>
                            <el-button @click="queryVideoList('nextMarker')" :disabled="!nextMarker" size="small"
                                type="primary">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                        </el-button-group>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="margin-bottom: 15px">
                    <el-link
                        href="https://mxjj-evaluate-online-live.oss-cn-beijing.aliyuncs.com/template/ossbrowser.docx?versionId=CAEQIhiBgMDhl5nK3xciIGJiNTA3ZjVkYTAyYjRmNDhhOGVkMjYxMzljMzM4MTFi"
                        type="primary" :underline="false">oss视频上传工具下载</el-link>
                </el-form-item>
            </el-form>
            <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
                :data="videoOssList" stripe @row-dblclick="rowClick" style="width: 100%">
                <el-table-column label="名称" prop="path">
                    <template slot-scope="scope">
                        <i style="color: #ffd04b" v-if="scope.row.isDir == 1" class="el-icon-folder"></i>
                        <i v-else class="el-icon-document"></i>
                        {{ scope.row.path }}
                    </template>
                </el-table-column>
                <el-table-column label="类型/大小" align="left" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.isDir == 1 ? "目录" : "资源"
                        }}{{ scope.row.formattedSize ? "/" + scope.row.formattedSize : "" }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isDir !== 1 && yuanh(scope.row)" size="small"
                            @click="selectvideo(scope.row)" type="text">选取</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { ERR_OK, BASE_URL } from '@/api/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
const editorConfig = {
    // JS 语法
    MENU_CONF: {
        uploadImage: {
            server: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
            customInsert(res, insertFn) {
                // JS 语法
                // res 即服务端的返回结果
                let url = res.data[0].url
                let alt = ''
                let href = res.data[0].url
                // 从 res 中找到 url alt href ，然后插入图片
                insertFn(url, alt, href)
            }
        },
        uploadVideo: {
            server: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
            customInsert(res, insertFn) {
                // JS 语法
                // res 即服务端的返回结果
                let url = res.data[0].url
                let poster = ''
                // 从 res 中找到 url alt href ，然后插入图片
                insertFn(url, poster)
            }
        }
    }

    // 其他属性...
}
export default {
    data() {
        return {
            ossDialog: false,
            prefix: "",
            ossUrl: ["read/"],
            videoOssList: [],
            marker: "",
            nextMarker: "",
            videoDisabled: false,
            pageArr: [],
            headers: {
                token: "" //文件上传请求头
            },
            xuelist: [
                { name: '老师使用', id: 0 },
                { name: '学生使用', id: 1 }
            ],
            upload: BASE_URL + "/evaluate//file/oss-upload",
            loading: false,
            datas: {
                bucketId: 2
            },
            editorConfig: editorConfig,
            mode: 'default', // or 'simple'
            toolbarConfig: {
                excludeKeys: ['group-video']
            },
            curPage: 1,
            editor1: null,
            ruleForm: {
                resId: '',
                resTitle: '',
                resTypeIds: [],
                resStepIds: [],
                resSourceId: '',
                resourceList: [],
                resSort: 0,
                resSourceTitle: '',
                resStepTitle: '',
                resTypeTitle: '',
                resContent: '',
                userType: [],
            },
            rules: {
                resTitle: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                    { max: 50, message: '长度最多50个字符', trigger: 'blur' }
                ],
                userType: [
                    { required: true, message: '请选择使用对象', trigger: 'blur' },
                ],
                resourceList: [
                    { required: true, message: '请选择或者上传资源文件', trigger: 'blur' },
                ],
                resStepIds: [
                    { required: true, message: '请选择资源阶段', trigger: 'blur' },
                ],
                resSourceId: [
                    { required: true, message: '请选择资源来源', trigger: 'blur' },
                ],
                resTypeIds: [
                    { required: true, message: '请选择资源类型', trigger: 'blur' },
                ],
            },
            headers: {
                token: '' //文件上传请求头
            },
            resource_typelist: [],
            resource_originlist: [],
            resource_steplist: [],
            bookLevelList: [],
            classinfo: []
        }
    },
    created() {
        this.headers.token = localStorage.getItem("token");
        if (this.$route.query.resId) {
            this.resourcegetInfo()
        }
        this.dictcode()
        this.dictcode1()
        this.dictcode2()
        this.dictcode3()
    },
    components: {
        Editor,
        Toolbar
    },
    watch: {

    },
    methods: {
        handlePreview(file) {
            // let url =
            //     "http://bk.welaiedu.cn/#/prepare_pdf?id=" +
            //     file.resId +
            //     "&token=" +
            //     localStorage.getItem("token");
            // window.open(url, "_blank");
            // localStorage.setItem('bookId','')
            // localStorage.setItem('fileUrl', this.ruleForm.serverHttp + file.fileUrl)
            // this.$emit('navlink', 'read_pre_view')
        },
        resourcegetInfo() {
            let that = this
            let params = {
                // bucketType: "live",
                resId:this.$route.query.resId,
            };
            homeApi.resourcegetInfo(params).then((res) => {
                if (res.data.code == 0) {
                    res.data.data.resStepIds = res.data.data.resStepIds.split(",")
                    res.data.data.resTypeIds = res.data.data.resTypeIds.split(",")
                    res.data.data.userType = res.data.data.userType.split(",")
                    for (var i = 0; i < res.data.data.resStepIds.length; i++) {
                        res.data.data.resStepIds[i] = parseInt(res.data.data.resStepIds[i])
                    }
                    for (var i = 0; i < res.data.data.resTypeIds.length; i++) {
                        res.data.data.resTypeIds[i] = parseInt(res.data.data.resTypeIds[i])
                    }
                    for (var i = 0; i < res.data.data.userType.length; i++) {
                        res.data.data.userType[i] = parseInt(res.data.data.userType[i])
                    }
                    for (var i = 0; i < res.data.data.resourceList.length; i++) {
                        res.data.data.resourceList[i].name = res.data.data.resourceList[i].fileName
                    }
                    this.ruleForm = res.data.data
                    console.log(this.ruleForm)
                }
            });
        },
        yuanh(vul) {
            let name = true
            for (var i = 0; i < this.classinfo.length; i++) {
                if (vul.name == this.classinfo[i].name) {
                    name = false
                }
            }
            return name
        },
        selectvideo(info) {
            info.name = info.name
            info.fileName = info.path
            info.fileUrl = info.fileName
            info.fileSize = info.size
            this.classinfo.push(info)
            console.log(this.classinfo)
            // this.ossDialog = false;
        },
        topUrl(url) {
            let idx = this.ossUrl.indexOf(url) + 1;
            if (!!this.ossUrl[idx]) {
                this.ossUrl.splice(idx, this.ossUrl.length);
                this.pageArr = [];
                this.queryVideoList();
            }
        },
        queryOss() {
            console.log(this.ossUrl);
            this.pageArr = [];
            this.queryVideoList(-1);
        },
        ossSelect() {
            this.queryVideoList();
            this.ossDialog = true;
        },
        // 单行双击
        rowClick(row) {
            let idx = row.name.indexOf(this.prefix);
            if (idx == -1) {
                this.ossUrl.push(this.prefix + row.name);
            } else {
                this.ossUrl.push(row.name);
            }
            this.prefix = "";
            this.pageArr = [];
            this.queryVideoList();
        },
        // 获取视频目录
        queryVideoList(state) {
            let url = "";
            this.ossUrl.forEach((item) => {
                url = url + item;
            });
            if (state == -1) {
                url = url + this.prefix;
            }
            let params = {
                // bucketType: "live",
                prefix: url,
                curPage: this.curPage,
                pageSize: 10,
            };
            let len = this.pageArr.length;
            if (state == "nextMarker") {
                params.marker = this.nextMarker;
                this.pageArr.push(this.nextMarker);
            }
            if (state == "marker") {
                if (len == 1) {
                    params.marker = null;
                } else {
                    params.marker = this.pageArr[len - 2];
                }
                this.pageArr.splice(len - 1, 1);
            }
            homeApi.queryVideoList(params).then((res) => {
                if (res.data.code == 0) {
                    this.videoOssList = res.data.data.objectList;
                    this.marker = res.data.data.marker;
                    this.nextMarker = res.data.data.nextMarker;
                }
            });
        },
        handleAvatarSuccess(res, file) {
            res.data[0].name = res.data[0].originalFilename
            res.data[0].fileName =res.data[0].fileName
            res.data[0].fileUrl = res.data[0].fileName
            res.data[0].fileSize = res.data[0].size
            this.ruleForm.resourceList.push(res.data[0])
        },
        handleRemove(res, file) {
            this.ruleForm.resourceList = file
        },
        onCreated1(editor) {
            this.editor1 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        goBack() {
            history.go(-1);
        },
        removeDuplicates(array) {
            return [...new Set(array)];
        },
        submitForm(formName) {
            let that = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.resourceList = this.ruleForm.resourceList.concat(this.classinfo);
                    this.ruleForm.resourceList = this.removeDuplicates(this.ruleForm.resourceList);
                    for (var i = 0; i < this.ruleForm.resourceList.length; i++) {
                        this.ruleForm.resourceList[i].fileName = this.ruleForm.resourceList[i].originalFilename?this.ruleForm.resourceList[i].originalFilename:this.ruleForm.resourceList[i].name
                    }
                    this.ruleForm.resTypeTitle = ''
                    for (var i = 0; i < that.resource_typelist.length; i++) {
                        for (var s = 0; s < this.ruleForm.resTypeIds.length; s++) {
                            if (that.resource_typelist[i].id == this.ruleForm.resTypeIds[s]) {
                                this.ruleForm.resTypeTitle += that.resource_typelist[i].name + ','
                            }
                        }
                    }
                    this.ruleForm.resStepTitle = ''
                    for (var i = 0; i < that.resource_steplist.length; i++) {
                        for (var s = 0; s < this.ruleForm.resStepIds.length; s++) {
                            if (that.resource_steplist[i].id == this.ruleForm.resStepIds[s]) {
                                this.ruleForm.resStepTitle += that.resource_steplist[i].name + ','
                            }
                        }
                    }
                    this.ruleForm.resSourceTitle = ''
                    for (var i = 0; i < that.resource_originlist.length; i++) {
                        if (that.resource_originlist[i].id == this.ruleForm.resSourceId) {
                            this.ruleForm.resSourceTitle = that.resource_originlist[i].name
                        }
                    }
                    let params = {
                        resId: this.ruleForm.resId,
                        resTitle: this.ruleForm.resTitle,
                        resTypeIds: this.ruleForm.resTypeIds.toString(),
                        resStepIds: this.ruleForm.resStepIds.toString(),
                        resSourceId: this.ruleForm.resSourceId.toString(),
                        resourceList: this.ruleForm.resourceList,
                        resSort: this.ruleForm.resSort,
                        resSourceTitle: this.ruleForm.resSourceTitle,
                        resStepTitle: this.ruleForm.resStepTitle,
                        resTypeTitle: this.ruleForm.resTypeTitle,
                        resContent: this.ruleForm.resContent,
                        userType: this.ruleForm.userType.toString(),
                        bookId:this.$route.query.bookId?this.$route.query.bookId:''
                    }
                    homeApi
                        .resourcesave(params)
                        .then((res) => {
                            that.$message({
                                type: 'success',
                                message: '保存成功!'
                            })
                            history.go(-1);
                            // if(localStorage.getItem('bookId')==''){
                            //     this.$emit('navlink', 'read_resources')
                            // }else{
                            //     this.$emit('navlink', 'read_newly')
                            // }
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            history.go(-1);
        },
        dictcode() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_type'
                })
                .then((res) => {
                    that.resource_typelist = res.data.data
                })
        },
        dictcode1() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_origin'
                })
                .then((res) => {
                    that.resource_originlist = res.data.data
                })
        },
        dictcode2() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_step'
                })
                .then((res) => {
                    that.resource_steplist = res.data.data
                })
        },
        dictcode3() {
            let that = this
            homeApi
                .dictcode({
                    code: 'school_feature'
                })
                .then((res) => {
                    that.bookLevelList = res.data.data
                })
        },
    }
}
</script>

<style lang="less" scoped></style>


// WEBPACK FOOTER //
// src/components/read/add.vue